import { render } from "./goRinSyo0003.vue?vue&type=template&id=7823a740"
const script = {}

import "./goRinSyo0003.vue?vue&type=style&index=0&id=7823a740&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__